export default "__VITE_ASSET__C73lIbRY__"